// extracted by mini-css-extract-plugin
export default {"addonModalBody":"RemoveAddonModal_addonModalBody__SD4-9"};